'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

FdcConfig=
function FdcConfig($stateProvider,$urlRouterProvider,$locationProvider,$httpProvider,$mdInkRippleProvider,$logProvider,$compileProvider){_classCallCheck(this,FdcConfig);
$mdInkRippleProvider.disableInkRipple();

$urlRouterProvider.otherwise(function($injector){
var $state=$injector.get('$state');
$state.go("fdc.features.emiratesDashboard");
});

$locationProvider.html5Mode({
enabled:!1,
requireBase:!1});


$httpProvider.useApplyAsync(!0);

$stateProvider.
state('fdc',{
abstract:!0,
views:{
header:{
templateUrl:'/templates/layout/header'},

alerts:{
templateUrl:'/templates/layout/alerts'},

tooltips:{
templateUrl:'/templates/layout/tooltips'}}}).



state('fdc.features',{
abstract:!0});


if("production"==='production'){

$logProvider.debugEnabled(!1);
$compileProvider.debugInfoEnabled(!1);








}

FastClick.attach(document.body);
};


module.exports=FdcConfig;

let _initialized=!1;
module.exports.runFunction=function($rootScope){
if(_initialized)
return;

_initialized=!0;
if("production"==='development'){
$rootScope.$on('$stateChangeError',function(event,toState,toParams,fromState,fromParams,error){
console.error('Got $stateChangeError:');
console.error(error);
});
}
};
module.exports.runFunction.$inject=['$rootScope'];
//# sourceMappingURL=fdcConfig.js.map
